<template>
  <div class="gallery">
    <div class="gallery-item" v-show="i === 0" v-for="(src, i) in srcList" :key="i">
      <DecryptImg
        :src="src"
        :initial-index="i"
        :i-preview-src-list="previewBlobs"
        @load="onImgLoad(i, $event)"
      ></DecryptImg>
    </div>
    <div v-if="srcList.length > 1" class="tag">
      <span>共{{ srcList.length }}张</span>
    </div>
    <div v-else-if="srcList.length < 1">
      <span>-</span>
    </div>
  </div>
</template>

<script>
import DecryptImg from "@/components/decrypt-img";

export default {
  name: "Gallery",
  props: ["list"],
  components: { DecryptImg },
  computed: {
    srcList() {
      const list = (Array.isArray(this.list) ? this.list : [this.list]).filter(
        (v) => !!v
      );
      return list;
    },
  },
  data() {
    return {
      index: 0,
      timer: null,
      previewBlobs: [],
    };
  },
  mounted() {},
  activated() {},
  deactivated() {},
  methods: {
    onImgLoad(i, e) {
      const arr = Object.assign([], this.previewBlobs);
      arr[i] = e.blob;
      this.previewBlobs = arr;
    },
  },
};
</script>

<style lang="scss" scoped>
.gallery {
  position: relative;
  margin: 0 auto;
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;

  .tag {
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 0px 8px;
    background-color: #0009;
    font-size: 10px;
    line-height: 16px;
    border-radius: 100px;
    color: #fff;
  }

  &-item {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
